// True when a Firestore doc is NOT soft-deleted (ADR-008). Handles both the boolean
// `true` and the legacy string `'true'` forms. Use as a client-side read filter —
// a Firestore `.where('Deleted','==',false)` would drop docs that lack the field.
//
// Applied centrally by the useFirestoreQuery engine (src/firebase/useFirestore.js),
// and directly by the read paths that bypass those hooks.
//
// AI-CONTEXT: See docs/decisions.md (ADR-008 soft deletes) and
// docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
const notDeleted = (doc) => doc?.Deleted !== true && doc?.Deleted !== 'true'

export default notDeleted
